import React from "react"; // eslint-disable-line no-unused-vars
import moment from "moment-timezone";
import "moment/locale/fr";
import Grid from "./Grid";
import * as utils from "./calendar-utils";


moment.tz.setDefault("Europe/Luxembourg");
moment.locale("fr");

class Calendar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      timeColumn: [],
      dayColumns: []
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.loading) {
      let timeColumn = utils.generateTimeColumn(
        nextProps.date,
        nextProps.baseDuration,
        nextProps.minTimeAdmin,
        nextProps.maxTimeAdmin
      );

      let dayColumns = utils.generateWeek(timeColumn, nextProps);

      return {
        timeColumn,
        dayColumns
      };
    } else {
      let timeColumn = utils.generateTimeColumn(
        nextProps.date,
        nextProps.baseDuration,
        nextProps.minTimeAdmin,
        nextProps.maxTimeAdmin
      );
      let dayColumns = utils.generateWeek(timeColumn, nextProps);
      let events = nextProps.events;
      let customSlots = nextProps.customSlots;
      utils.addEvents(dayColumns, events, nextProps, nextProps.draggingEventId);
      utils.addCustomEvents(dayColumns, customSlots, nextProps);
      /*
      if (myWorker === null) {
        myWorker = new WebWorker(worker);
        console.log("created worler", "workerrr");
        myWorker.postMessage({ truc: "sdlkj" });
      }
*/
      return {
        dayColumns,
        timeColumn
      };
    }
  }

  render() {
    return (
      <Grid
        minTime={this.props.minTimeAdmin}
        maxTime={this.props.maxTimeAdmin}
        baseDuration={this.props.baseDuration}
        marginTop={this.props.marginTop}
        nbrRows={this.state.timeColumn.length}
        loading={this.props.loading}
        timeColumn={utils.renderTimeColumn(this)}
        columns={utils.renderWeek(this)}
        nbrCols={this.props.view === "week" ? 7 : 1}
      />
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/utilities/calendar/Calendar.js